import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import Icon from './Icon';

interface FileUploadProps {
    onFileSelected: (file: File) => void;
    maxSizeMB?: number;
    accept?: string;
    label?: string;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileSelected, maxSizeMB = 10, accept, label }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const { t } = useTranslation();

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || event.target.files.length === 0) return;
        const file = event.target.files[0];

        if (file.size > maxSizeMB * 1024 * 1024) {
            alert(`Fichier trop volumineux (max ${maxSizeMB} Mo)`);
            return;
        }

        setSelectedFile(file);
        onFileSelected(file);
    };

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Button variant="outlined" component="label" startIcon={<Icon name="backup" />}>
                {label || capitalizeFirstLetter(t('selectFile'))}
                <input type="file" hidden accept={accept} onChange={handleFileChange} />
            </Button>
        </Box>
    );
};

export default FileUpload;
